// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/" + "38e0e335d52b55b0b13f" + ".styles.css";
};